<template>
	<div>
		<Header />
		<div class="bannerWrap">
			<img class="bannerImg" :src="`${imgPath}/static/assets/img/news/banner.jpg?2`" />
			<cloud />
		</div>
		<div class="notice-content">
            <div class="crumbWrap"><span @click="link2News">{{crumbs1.name}}</span> <i>&gt;</i> {{ $t('news_detail') }}</div>
            <div class="contentWrap">
                <p class="title">{{detail.title}}</p>
                <p class="date">{{detail.created_at|timeFormatString}}</p>
                <div class="desc" v-html="detail.content"></div>
            </div>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				id:this.$route.params.id,
                detail:{},
                crumbs1:{},
			}
		},
		created() {
			this.getNoticeDetail()
		},
		methods: {
			getNoticeDetail(){
                this.$api.getNoticeDetail({id:this.id,lang:localStorage.getItem('language') || 'zh-cn'}).then(res=>{
                    if(!res.code){
                        this.detail = res.data.detail;
                        this.crumbs1 = res.data.crumbs[0];
                        return false
                    }
                });
            },
            link2News(){
                this.$router.push({name:'news'})
            }
		}
	}
</script>
<style>
.desc img {
    width: 100% !important;
    height: auto !important;
}
.desc p {
    margin-bottom: 0.1rem;
}
</style>
<style lang="scss" scoped>
	.bannerWrap{
		position: relative;
		width: 100%;
		.bannerImg {
			width: 100%;
		}
	}
	.notice-content{
		padding: 0 0.82rem;
        box-sizing: border-box;
        .crumbWrap {
            font-size: 0.24rem;
            color: #7A7A7A;
            margin-top: 0.52rem;
        }
        .contentWrap {
            .title{
                font-size: 0.28rem;
                font-weight: bold;
                color: #000000;
                margin-top: 0.7rem;
            }
            .date{
                font-size: 0.22rem;
                color: #7A7A7A;
                margin-top: 0.25rem;
            }
            .desc{
                font-size: 0.24rem;
                color: #7A7A7A;
                margin-top: 0.6rem;
                line-height: 0.4rem;
            }
        }
	}
</style>


// WEBPACK FOOTER //
// src/views/news/detail.vue